import React from "react";
import { TextField as MSTextField } from "@fluentui/react";
import { useField } from "formik";

const TextField = (props) => {
  const [field, meta] = useField(props);
  return (
    <MSTextField
      {...field}
      {...props}
      errorMessage={meta.touched && meta.error}
    />
  );
};

export default TextField;
